import React from "../../__compat__/react/main.entry.mjs.mjs";
import { useSpacing } from "../../api/spacing/useSpacing.mjs.mjs";
import { useLocale } from "../LocaleProvider/index.mjs.mjs";
import { pickDataProps, pickComponentCommonProps, } from "../../interfaces/commonProps.mjs.mjs";
import { StyledValue, StyledUnit, StyledValueUnitContainer, StyledDescription, StyledTitle, StyledContainer, } from "./ValueWithUnit.styles.mjs.mjs";
function valueAsNumber(value) {
    const parsedValue = Number(value);
    return !Number.isNaN(parsedValue) ? parsedValue : undefined;
}
function isNumber(value) {
    return typeof value === 'number';
}
let labelId = 0;
let descriptionId = 0;
const getLabelId = () => {
    return `ValueWithUnit-Label-${labelId++}`;
};
const getDescriptionId = () => {
    return `ValueWithUnit-Description-${descriptionId++}`;
};
export const ValueWithUnit = React.forwardRef(({ description: label, title: topline, value, unit, unitType = 'decimal', alignment = 'center', size = 'medium', ...restProps }, ref) => {
    const { current: internalLabelId } = React.useRef(getLabelId());
    const { current: internalDescriptionId } = React.useRef(getDescriptionId());
    const { localeIdentifier } = useLocale();
    const outerSpacing = useSpacing(restProps);
    const valueFormatter = React.useMemo(() => new Intl.NumberFormat(localeIdentifier), [localeIdentifier]);
    const unitFormatter = React.useMemo(() => {
        // Handle potential error while creating formatter due to unsupported input
        try {
            return Intl.NumberFormat(localeIdentifier, {
                style: unitType,
                unitDisplay: 'short',
                unit: unitType === 'unit' ? unit : undefined,
                currency: unitType === 'currency' ? unit : undefined,
                currencyDisplay: 'code',
            });
        }
        catch (error) {
            console.warn(error);
            return valueFormatter;
        }
    }, [valueFormatter, localeIdentifier, unit, unitType]);
    const parsedValue = valueAsNumber(value);
    const innerValue = isNumber(parsedValue)
        ? valueFormatter.format(parsedValue)
        : value;
    const innerUnit = React.useMemo(() => {
        var _a;
        return isNumber(parsedValue)
            ? ((_a = unitFormatter
                .formatToParts(parsedValue)
                .find((item) => ['currency', 'unit', 'percentSign'].includes(item.type))) === null || _a === void 0 ? void 0 : _a.value) || unit
            : unit;
    }, [parsedValue, unit, unitFormatter]);
    return (React.createElement(StyledContainer, { ref: ref, alignment: alignment, size: size, outerSpacing: outerSpacing, ...pickComponentCommonProps(restProps), ...pickDataProps(restProps) },
        topline && (React.createElement(StyledTitle, { id: internalLabelId, size: size }, topline)),
        React.createElement(StyledValueUnitContainer, { alignment: alignment, "aria-labelledby": topline ? internalLabelId : internalDescriptionId, "aria-describedby": topline ? internalDescriptionId : undefined },
            React.createElement(StyledValue, { size: size }, innerValue),
            React.createElement(StyledUnit, { size: size }, innerUnit)),
        React.createElement(StyledDescription, { id: internalDescriptionId, size: size }, label)));
});
ValueWithUnit.displayName = ValueWithUnit.name;
//# sourceMappingURL=ValueWithUnit.mjs.mjs.map